export const getAuthToken = () => {
  try {
    const authUser = localStorage.getItem("authUser");
    if (!authUser) return null;

    const parsed = JSON.parse(authUser);
    return parsed?.data?.token || null;
  } catch (error) {
    console.error("Invalid authUser in localStorage");
    return null;
  }
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};
